import React from "react"

import { ProjectPhaseChip } from "entities/projects/ui/project-phase-chip/ProjectPhaseChip"
import { ProjectRoleChip } from "entities/projects/ui/project-role-chip/ProjectRoleChip"
import { ProjectCard } from "features/project-management/ui/project-card/ProjectCard"

export const ProjectsOverviewCardLoader = React.memo(() => {
  return (
    <div
      className="projects-overview-card"
      data-testid="projects-overview-card"
    >
      <ProjectCard isLoading className="card--elevated project-card--overview">
        <ProjectCard.Image />
        <ProjectCard.Title />
        <ProjectCard.Chips>
          <ProjectPhaseChip phase={null} isLoading />
          <ProjectRoleChip teamRole={null} isLoading />
        </ProjectCard.Chips>
        <ProjectCard.Body />
      </ProjectCard>
    </div>
  )
})
